import React from 'react';
import {
  Platform,
} from 'react-native';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';
import PublisherBadge from './PublisherBadge';
import Publisher from '../../modules/data/Publisher';
import AORTypes from '../../types';

function MyPublisherBadge(props) {
  const {
    publisher,
    style,
    user,
    userData,
    onAddUserImage,
    updateUserData,
    getUploader,
  } = props;

  // TODO(clairbee): drop the props 'user' and 'userData'
  if (!user || !userData) {
    return (
      <>
      </>
    );
  }

  return (
    <PublisherBadge
      style={style}
      publisher={publisher}
      onPhotoPress={(e) => (
        // FIXME(clairbee): implement the feedback on the upload status/progress
        Platform.OS !== 'web'
          ? getUploader().handleMobilePhotoUpload('Select a profile photo', publisher.data.uuid, onAddUserImage, updateUserData, () => { }, {}, e)
          : getUploader().handleWebUpload('file', publisher.data.uuid, onAddUserImage, updateUserData, () => { }, {}, e)
      )}
    />
  );
}

MyPublisherBadge.defaultProps = {
  style: {},
};

MyPublisherBadge.propTypes = {
  user: AORTypes.AWS.Cognito.User.isRequired,
  userData: AORTypes.User.isRequired,
  publisher: PropTypes.instanceOf(Publisher).isRequired,
  onAddUserImage: PropTypes.func.isRequired,
  updateUserData: PropTypes.func.isRequired,
  getUploader: PropTypes.func.isRequired,
  style: ViewPropTypes.style,
};

export default MyPublisherBadge;
